module.exports = __webpack_public_path__ + "img/setting_icon.4cc74dad.svg";